export const SITE_URL = "https://www.orvellaoverseas.com";
export const COMPANY = "Orvella Overseas Private Limited";
export const TAGLINE = "Connecting Global Opportunities";
export const PHONE_DISPLAY = "+91 99735 19755";
export const PHONE_TEL = "tel:+919973519755";
export const EMAIL = "info@orvellaoverseas.com";
export const ADDRESS = "Western Mall 606, RPS More, Bailey Road, Patna 801503, Bihar, India";
export const LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/wingman/8fa67498-0a66-43c8-9715-099cf4f95dd9/attachments/dde30137357c41b5a385e9a245c9b471_WhatsApp%20Image%202026-10-20%20at%201.24.36%20PM.jpeg";
export const DHIRAJ_PHOTO = "https://customer-assets-cm19k8pv.emergentagent.net/wingman/8fa67498-0a66-43c8-9715-099cf4f95dd9/attachments/f9c3e1baa2a14de28d519c374fcdb414_WhatsApp%20Image%202026-10-20%20at%201.28.22%20PM.jpeg";
export const HERO_IMAGE = "https://images.pexels.com/photos/32810636/pexels-photo-32810636.jpeg?auto=compress&cs=tinysrgb&w=1920";
export const PORT_IMAGE = "https://images.unsplash.com/photo-1699421074746-39a8eefc4bf0?q=85&w=1600&auto=format&fit=crop";
export const TERRACES_IMAGE = "https://images.pexels.com/photos/15083318/pexels-photo-15083318.jpeg?auto=compress&cs=tinysrgb&w=1600";
export const WORLD_MAP_IMAGE = "https://static.prod-images.emergentagent.com/jobs/97e958b2-7e84-4380-9c02-6f4dc97bd961/images/07baa91f2a4ee5454de6720db57b00d89741ea65eaff848086f349b50956ab3b.jpeg";

export const DEFAULT_WA_MSG =
  "Hello Orvella Overseas, I am interested in sourcing food products from India. I would like to discuss my requirements.";

export const waLink = (msg) =>
  `https://wa.me/919973519755?text=${encodeURIComponent(msg || DEFAULT_WA_MSG)}`;

export const track = (name, meta = {}) => {
  try {
    const body = JSON.stringify({ name, path: window.location.pathname, meta });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${process.env.REACT_APP_BACKEND_URL}/api/events`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
    if (window.gtag) window.gtag("event", name, meta);
  } catch (e) {
    /* analytics must never break the page */
  }
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Products" },
  { to: "/why-orvella", label: "Why Orvella" },
  { to: "/quality", label: "Quality" },
  { to: "/export-process", label: "Export Process" },
  { to: "/markets", label: "Markets" },
  { to: "/private-label", label: "Private Label" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export const TRUST_ITEMS = [
  { icon: "MapPin", title: "Indian Sourcing", text: "Quality-focused sourcing from India" },
  { icon: "Handshake", title: "B2B Supply", text: "Built for international buyers" },
  { icon: "Package", title: "Flexible Packaging", text: "Packaging options based on buyer requirements" },
  { icon: "Ship", title: "Export Coordination", text: "Professional order and shipment coordination" },
  { icon: "MessagesSquare", title: "Buyer Support", text: "Responsive communication from enquiry to shipment" },
];

export const WHO_WE_SERVE = [
  { icon: "ArrowDownToLine", title: "Importers", text: "For companies sourcing Indian food products." },
  { icon: "Truck", title: "Distributors", text: "For regional and national distribution businesses." },
  { icon: "Boxes", title: "Wholesalers", text: "For bulk food product procurement." },
  { icon: "Store", title: "Retailers", text: "For packaged food and private-label opportunities." },
  { icon: "UtensilsCrossed", title: "Food-Service Businesses", text: "For restaurants, hotels and institutional buyers." },
  { icon: "Factory", title: "Food Manufacturers", text: "For ingredients and food-processing applications." },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Requirement", text: "Buyer shares product and quantity requirements." },
  { n: "02", title: "Product Selection", text: "Suitable products and specifications are discussed." },
  { n: "03", title: "Quotation", text: "Commercial quotation based on agreed requirements." },
  { n: "04", title: "Sample / Approval", text: "Samples can be arranged where applicable." },
  { n: "05", title: "Order Confirmation", text: "Buyer and supplier finalize commercial terms." },
  { n: "06", title: "Quality & Packaging", text: "Product preparation and packaging according to agreed requirements." },
  { n: "07", title: "Documentation", text: "Required export documentation is coordinated." },
  { n: "08", title: "Shipment", text: "Shipment and logistics coordination." },
];

export const WHY_ORVELLA = [
  { icon: "MapPin", title: "India-Based Product Sourcing", text: "Access a diverse portfolio of Indian food and agricultural products." },
  { icon: "Handshake", title: "B2B-Focused Approach", text: "Designed around importers, distributors, wholesalers, retailers and food businesses." },
  { icon: "SlidersHorizontal", title: "Buyer-Specific Requirements", text: "Support product, packaging and documentation requirements according to feasibility." },
  { icon: "LayoutGrid", title: "Product Diversity", text: "Rice, spices, makhana, tea, peanuts, dehydrated products and food powders." },
  { icon: "MessagesSquare", title: "Professional Communication", text: "Clear communication throughout the enquiry and order process." },
  { icon: "Ship", title: "Export Coordination", text: "Support for documentation, packaging and shipment coordination as applicable." },
];
